import { useSwiper } from "swiper/react";
import Arrow from "@/public/assets/images/arrow-circle-left.svg";

type CarouselButtonsProps = {
  disablePrev: boolean;
  disableNext: boolean;
};

const CarouselButtons = ({
  disableNext,
  disablePrev,
}: CarouselButtonsProps) => {
  const swiper = useSwiper();
  return (
    <div className="grid-images-with-carousel__buttons">
      <button
        className="grid-images-with-carousel__button grid-images-with-carousel__button--prev"
        onClick={() => {
          swiper.slidePrev();
        }}
        disabled={disablePrev}
      >
        <Arrow />
      </button>
      <button
        className="grid-images-with-carousel__button grid-images-with-carousel__button--next"
        onClick={() => {
          swiper.slideNext();
        }}
        disabled={disableNext}
      >
        <Arrow />
      </button>
    </div>
  );
};

export default CarouselButtons;
